import { FC, PropsWithChildren, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useTODO, UseTODOOptions } from '../hooks/useTODO';

export type TODOProps = UseTODOOptions &
  PropsWithChildren & {
    redirect?: boolean;
    render?: (hide: boolean) => ReactNode;
  };

export const TODO: FC<TODOProps> = ({
  children,
  redirect,
  render,
  ...opts
}) => {
  const hide = useTODO(opts);

  if (hide) {
    if (redirect) {
      return <Navigate to="/" />;
    }
    return render?.(hide) ?? <></>;
  }

  const content = children ?? render?.(hide);

  if (!import.meta.env.PROD) {
    return (
      <div className="border-2 border-dashed border-red-200">{content}</div>
    );
  }
  return content;
};
